var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16471 15.8333H5.35221L13.498 7.6875L12.3105 6.5L4.16471 14.6458V15.8333ZM2.49805 17.5V13.9583L13.498 2.97917C13.6647 2.82639 13.8487 2.70833 14.0501 2.625C14.2515 2.54167 14.4633 2.5 14.6855 2.5C14.9078 2.5 15.123 2.54167 15.3314 2.625C15.5397 2.70833 15.7203 2.83333 15.873 3L17.0189 4.16667C17.1855 4.31944 17.3071 4.5 17.3835 4.70833C17.4599 4.91667 17.498 5.125 17.498 5.33333C17.498 5.55556 17.4599 5.76736 17.3835 5.96875C17.3071 6.17014 17.1855 6.35417 17.0189 6.52083L6.03971 17.5H2.49805ZM12.8939 7.10417L12.3105 6.5L13.498 7.6875L12.8939 7.10417Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.be9f8dac3d31c08b1afba456b322806b.svg";
export { ForwardRef as ReactComponent };